import * as React from 'react'

// reducers
import { Reducer, KEYS } from './reducer'
import { initialState, StateProps } from './initial'

// configs
import checkPackageVersion from '../../configs/utils/npm'

const actions = () => {

  // ** States
  const [state, dispatch]: [StateProps, any] = React.useReducer(Reducer, initialState)

  React.useEffect(() => {

    cls.getNpmPackageVersion()

  }, [])

  // ** Classes
  const cls = new class {

    get state() {
      return state
    }

    dispatch(payload: unknown) {
      dispatch({
        type: KEYS.UPDATE,
        payload,
      })
    }

    async getNpmPackageVersion() {
      const packageVersion = await checkPackageVersion()
      this.dispatch({ packageVersion })
    }
  }

  return cls
}

export interface ActionProps {
  state: StateProps,
  getNpmPackageVersion: object
}

export default actions
